import * as actionTypes from '../action-types';
import { NotificationsActions } from '../actions';

const defaultState: boolean = false;

export function isNewReducer(
  state: boolean = defaultState,
  action: NotificationsActions,
) {
  switch (action.type) {
    case actionTypes.SET_IS_NEW: {
      const { isNew } = action.payload;

      if (state !== isNew) {
        return isNew;
      }
      return state;
    }
    default: {
      return state;
    }
  }
}
